import { EditPageButtons } from './EditPageButtons.main';

export { EditPageButtons };
